module.exports = __webpack_public_path__ + "static/img/turntable_checked2.0342c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/turntable_checked2.png
// module id = 6ni+
// module chunks = 1